import React, { useState, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import LogoService from '../../services/logo.service';
import { Container, Row, Col } from "react-bootstrap";

const AddLogoSetModal = (props) => {
    const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const [logoLocations, setLogoLocations] = useState(null);
  const [logos, setLogos] = useState(null);
  const [logoLocationPairs, setLogoLocationPairs] = useState([]);
  const [updateMode, setUpdateMode] = useState('color');
  const [kitOnly, setKitOnly] = useState(false);


  const modalClose = () => {
    resetForm();
    props.closeModal(false);
  }

  useEffect(() => {
    async function fetchData() {
        var loadedLogos = await LogoService.getLogosForSubsite();
        setLogos(loadedLogos.data);

        var newLogoLocations = await LogoService.getLogoLocations();
        setLogoLocations(newLogoLocations.data);

    }
    fetchData();
  }, []);

  const resetForm = () => {
    setLogoLocationPairs([]);
    setKitOnly(false);
  }

  const addLogoLocationPair = (logoId, locationId) => {
    const newPairs = logoLocationPairs.filter(pair => pair.locationId !== locationId);
    newPairs.push({ logoId, locationId });
    setLogoLocationPairs(newPairs);
  }

  const removeLogoLocationPair = (locationId) => {
    const newPairs = logoLocationPairs.filter(pair => pair.locationId !== locationId);
    setLogoLocationPairs(newPairs);
  }

  const isLocationAssigned = (locationId) => {
    return logoLocationPairs.some(pair => pair.locationId === locationId);
  }

  const getAssignedLogo = (locationId) => {
    const pair = logoLocationPairs.find(pair => pair.locationId === locationId);
    return pair ? logos.find(logo => logo.id === pair.logoId) : null;
  }

  const handleSubmit = () => {
    if (logoLocationPairs.length === 0) {
      alert("Please assign at least one logo to a location before submitting.");
      return;
    }
    var logoSet = [];

    // Call addLogo for each logo-location pair
    logoLocationPairs.forEach(pair => {
      const logo = logos.find(l => l.id === pair.logoId);
      logoSet.push({locationId: pair.locationId, logo: logo});
    });
    props.addLogo(logoSet, updateMode, kitOnly);

    resetForm();
    props.closeModal(false);
  }

    const updateModeChanged = (mode) => {
        setUpdateMode(mode);
    }

  
  return (
    <Modal show={props.show} onHide={modalClose} size="xl">
    <Modal.Header closeButton>
      <Modal.Title>Add Multiple Logo Assignments<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>
    <Container>

                    <Row>
                      <Col>
                        Update Mode:
                        </Col>
                        <Col>
                        <input type="radio" id="color" name="updateMode" onChange={() => updateModeChanged('color')} checked={updateMode === "color"} /> Update this color<br/>
                        <input type="radio" id="all"  name="updateMode" onChange={() => updateModeChanged('all')} checked={updateMode === "all"}/> Update All Colors
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        New Hire Kit Only:
                      </Col>
                      <Col>
                        <label>
                          <input type="checkbox" checked={kitOnly} onChange={(e) => setKitOnly(e.target.checked)} />
                          {' '}Hide from catalog &mdash; only show when added to a New Hire Kit
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Available Locations:
                      </Col>
                      <Col>
                        {logoLocations && logoLocations.map((location) => {
                          const assignedLogo = getAssignedLogo(location.id);
                          return (
                            <div key={location.id} style={{border: "1px solid #ccc", margin: "5px", padding: "10px", display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                              <div style={{display: "flex", alignItems: "center"}}>
                                <div style={{marginRight: "15px"}}>
                                  {assignedLogo ? (
                                    assignedLogo.oppoColor ? (
                                      <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                                        <img alt="Logo" src={apiUrl + assignedLogo.imageUrl} style={{width: "50px", height: "50px", objectFit: "contain", backgroundColor: "#CCCCCC", padding: "3px", margin: "1px"}} />
                                        <img alt="Logo" src={apiUrl + assignedLogo.oppoColor.imageUrl} style={{width: "50px", height: "50px", objectFit: "contain", backgroundColor: "#CCCCCC", padding: "3px", margin: "1px"}} />
                                      </div>
                                    ) : (
                                      <img alt="Logo" src={apiUrl + assignedLogo.imageUrl} style={{width: "60px", height: "60px", objectFit: "contain", backgroundColor: "#CCCCCC", padding: "5px"}} />
                                    )
                                  ) : (
                                    <div style={{width: "60px", height: "60px", backgroundColor: "#f0f0f0", border: "2px dashed #ccc", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", color: "#999"}}>
                                      No Logo
                                    </div>
                                  )}
                                </div>
                                <div>
                                  <div><strong>{location.description}</strong></div>
                                  {assignedLogo ? (
                                    <div>
                                      <div style={{color: "green"}}>
                                        <strong>Assigned:</strong> {assignedLogo.decorationName}
                                      </div>
                                      <div style={{color: "#666", fontSize: "12px"}}>
                                        Type: {assignedLogo.decoType}
                                      </div>
                                    </div>
                                  ) : (
                                    <div style={{color: "#666"}}>No logo assigned</div>
                                  )}
                                </div>
                              </div>
                              {assignedLogo && (
                                <button
                                  onClick={() => removeLogoLocationPair(location.id)}
                                  style={{
                                    backgroundColor: "#dc3545",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "3px",
                                    padding: "5px 10px",
                                    cursor: "pointer"
                                  }}
                                >
                                  Remove
                                </button>
                              )}
                            </div>
                          );
                        })}
                      </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button
                              onClick={handleSubmit}
                              disabled={logoLocationPairs.length === 0}
                              style={{
                                backgroundColor: logoLocationPairs.length === 0 ? "#ccc" : "#007bff",
                                borderColor: logoLocationPairs.length === 0 ? "#ccc" : "#007bff"
                              }}
                            >
                              Add Logo Assignments ({logoLocationPairs.length})
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                          <h5>Available Logos</h5>
                          <div>Click on a logo, then select a location to assign it to:</div>
                          {logos && logos.map((logo) => {
                              const logoDiv = (
                                <div key={logo.id} style={{border: "1px solid #000000", margin: "10px", padding: "10px"}}>
                                  <div style={{display: "flex", alignItems: "center"}}>
                                    {logo.oppoColor ? (
                                      <>
                                        <img alt="Logo" src={apiUrl + logo.imageUrl} style={{margin: 5, width: "100px", padding: 5, backgroundColor: "#CCCCCC"}} />
                                        <img alt="Logo" src={apiUrl + logo.oppoColor.imageUrl} style={{margin: 5, width: "100px", padding: 5, backgroundColor: "#CCCCCC"}} />
                                      </>
                                    ) : (
                                      <img alt="Logo" src={apiUrl + logo.imageUrl} style={{margin: 5, width: "100px", padding: 5, backgroundColor: "#CCCCCC"}} />
                                    )}
                                    <div style={{marginLeft: "10px"}}>
                                      <div><strong>{logo.decorationName}</strong></div>
                                      <div>Type: {logo.decoType}</div>
                                    </div>
                                  </div>
                                  <div style={{marginTop: "10px"}}>
                                    <strong>Assign to location:</strong>
                                    {logoLocations && logoLocations.map((location) => (
                                      <button
                                        key={location.id}
                                        onClick={() => addLogoLocationPair(logo.id, location.id)}
                                        disabled={isLocationAssigned(location.id)}
                                        style={{
                                          margin: "5px",
                                          padding: "5px 10px",
                                          backgroundColor: isLocationAssigned(location.id) ? "#ccc" : "#007bff",
                                          color: isLocationAssigned(location.id) ? "#666" : "white",
                                          border: "none",
                                          borderRadius: "3px",
                                          cursor: isLocationAssigned(location.id) ? "not-allowed" : "pointer"
                                        }}
                                      >
                                        {location.description} {isLocationAssigned(location.id) ? "(Assigned)" : ""}
                                      </button>
                                    ))}
                                  </div>
                                </div>
                              );
                              return logoDiv;
                          })}
                        </Col>
                    </Row>
                </Container>
    </Modal.Body>
    </Modal>
  );
};

export default AddLogoSetModal;